module.exports = __webpack_public_path__ + "static/media/Distributor report.22668451.png";